<button
  type="button"
  [class]="itemClass"
  [attr.role]="'radio'"
  [attr.aria-checked]="isActive"
  [attr.aria-disabled]="isDisabled || null"
  [attr.tabindex]="isActive ? 0 : -1"
  [disabled]="isDisabled">
  <span class="hc-segmented__icon">
    <ng-content select="[segmentIcon]"></ng-content>
  </span>
  <span class="hc-segmented__label">
    <ng-content></ng-content>
  </span>
</button>
